<template>
  <v-dialog v-model="isVisible" persistent fullscreen>
    <v-stepper v-model="orderStep" alt-labels width="100%">
      <v-app-bar class="headline font-weight-bold" flat>
        {{ (language === 'en_US') ? menuItem.productGroupEnglishName : menuItem.productGroupName }}
      </v-app-bar>
      <v-stepper-header>
        <v-stepper-step :complete="orderStep > (sIdx + 1)" v-for="(sMenu, sIdx) in stepMenu" :key="`step-${sIdx + 1}`"
          :step="sIdx + 1">
          <span> {{ getUnitedName(sMenu.unitedName) }}</span>
        </v-stepper-step>
        <v-divider :key="`divider-${sIdx + 1}`"></v-divider>
        <v-stepper-step :complete="orderStep > (stepMenu.length + 1)" :step="stepMenu.length + 1">
          <span> {{ labels.count[language] }}</span>
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items v-show="!showMainItemNotice">
        <v-stepper-content v-for="(sMenu, sIdx) in stepMenu" :key="`stepperContent-${sIdx + 1}`" :step="sIdx + 1">
          <v-tabs v-model="tab[sIdx]" background-color="primary" light>
            <v-tab v-for="item in sMenu.unitedItems" :key="`tab-${item.productGroupSelectTypeId}`">
              {{ getProductTypeName(item.productGroupSelectTypeId) }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab[sIdx]">
            <v-tab-item v-for="item in sMenu.unitedItems" :key="`tabItem-${item.productGroupSelectTypeId}`">
              <v-container fluid style="min-height:800px">
                <v-list two-line>
                  <v-list-item v-for="product in item.products" :key="`col-${product.productId}`"
                    @click="onItemSelecting(sIdx, product)">
                    <v-list-item-avatar horizontal height="60" width="60">
                      <v-img :src="getMenuImgSrc(product.productId)">
                      </v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="title font-weight-bold" v-html="getMenuItemName(product.productId)" />
                      <v-list-item-subtitle class="font-weight-bold" v-html="getMenuItemDescription(product.productId)">
                      </v-list-item-subtitle>
                      <v-list-item-subtitle class="primary--text headline font-weight-bold" v-html="(product.discountAmount)
                        ? `+ ${product.discountAmount}` : ''">
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
          <v-footer color="white" app>
            <v-row class="pa-0">
              <v-col class="pr-0 pl-0">
                <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="orderStep = sIdx" block depressed
                  :disabled="orderStep === 1">
                  {{ labels.prev[language] }}
                </v-btn>
              </v-col>
              <v-col class="pr-0 pl-0">
                <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="close" block outlined>
                  {{ labels.cancel[language] }}
                </v-btn>
              </v-col>
              <v-col class="pr-0 pl-0">
                <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="selectItem" block depressed
                  :disabled="!orderDone">
                  {{ labels.add[language] }} (${{ subTotal }})
                </v-btn>
              </v-col>
            </v-row>
          </v-footer>
        </v-stepper-content>
        <v-stepper-content :step="stepMenu.length + 1">
          <v-container pa-10 fluid style="min-height:600px">
            <v-row v-for="(rowItem, rowIndex) in keyboard" :key="`keyboard-row-${rowIndex}`">
              <v-col v-for="(colItem, colIndex) in rowItem" :key="`keyboard-col-${rowIndex}-${colIndex}`">
                <v-btn class="text-h5 font-weight-bold" color="primary" @click="keyIn(colItem)" x-large block rounded
                  :outlined="orderCount !== parseInt(colItem, 10)">{{
                    colItem
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-footer color="white" app>
            <v-row class="pa-0">
              <v-col class="pr-0 pl-0">
                <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="orderStep -= 1" block depressed
                  :disabled="orderStep === 1">
                  {{ labels.prev[language] }}
                </v-btn>
              </v-col>
              <v-col class="pr-0 pl-0">
                <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="close" block outlined>
                  {{ labels.cancel[language] }}
                </v-btn>
              </v-col>
              <v-col class="pr-0 pl-0">
                <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="selectItem" block depressed
                  :disabled="!orderDone">
                  {{ labels.add[language] }} (${{ subTotal }})
                </v-btn>
              </v-col>
            </v-row>
          </v-footer>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-container v-show="showMainItemNotice" fluid>
      <v-card>
        <v-card-title class="headline primary--text font-weight-bold">
          {{ noticeMainItemInfo.productName }}
        </v-card-title>

        <v-img class="white--text align-end" height="160px" :src="noticeMainItemInfo.imgSrc" contain>
        </v-img>
        <v-divider></v-divider>
        <v-container fluid>
          <v-tabs v-model="additionalTypeTab" background-color="transparent" color="primary" grow>
            <v-tab class="title" v-for="(items, itemTypeName) in noticeMainItemInfo.additionTypes"
              :key="`tab-${itemTypeName}`">
              {{ itemTypeName }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="additionalTypeTab">
            <v-tab-item v-for="(items, itemTypeName) in noticeMainItemInfo.additionTypes"
              :key="`tabItems-${itemTypeName}`">
              <v-container fluid>
                <p class="primary--text" style="margin-top:8px;margin-bottom:8px;">{{ limitText(items[0].productTypeId)
                  }}</p>
                <v-row v-for="item of items" :key="item.productId">
                  <v-checkbox v-model="additionalSelected" :label="`${getAdditionalName(item)}`" :value="item"
                    :disabled="handleLimit(item)" class="shrink checkbox-large" color="primary"
                    hide-notices></v-checkbox>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-container>
            <p class="red--text">{{ errorMessage }}</p>
            <v-row class="pa-0">
              <v-col class="pr-0 pl-0">
                <v-btn class="headline font-weight-bold" color="primary" @click="closeNotice" large block outlined>{{
                  labels.cancel[language] }}
                </v-btn>
              </v-col>
              <v-col class="pr-0 pl-0">
                <v-btn class="headline font-weight-bold" color="primary"
                  @click="nextStep(currentStepIndex, noticeMainItem, noticeMainItemInfo.additionTypes)" large block
                  depressed>{{
                    labels.add[language] }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
</template>
<script>
const defaultTabValue = {
  0: null,
  1: null,
  2: null,
  3: null,
  4: null,
};
const defaultAdditionalObj = {
  additionalOfProduct1: null,
  additionalOfProduct2: null,
  additionalOfProduct3: null,
  additionalOfProduct4: null,
  additionalOfProduct5: null,
};

export default {
  name: 'GroupMenuDialog',
  props: ['dialog', 'menuItem'],
  data() {
    return {
      labels: {
        prev: {
          en_US: 'PREV.',
          zh_TW: '上一頁',
        },
        cancel: {
          en_US: 'CANCEL',
          zh_TW: '取消',
        },
        add: {
          en_US: 'ADD',
          zh_TW: '確定',
        },
        remark: {
          en_US: 'REMARK',
          zh_TW: '註記',
        },
        count: {
          en_US: 'COUNT',
          zh_TW: '數量',
        },
      },
      isVisible: false, // 視窗開關
      itemSelected: {}, // 所選套餐組合
      groupSelected: [], // 所選套餐主要項目
      orderStep: 0, // 步進式選單目前所在步驟
      orderDone: false, // 套餐選擇完成
      orderCount: 1, // 點餐數量
      tab: { ...defaultTabValue }, // 套餐組合中的種類，最多不能超過5種
      amountSelected: [], // 所選套餐組合的分項價格,
      itemPage: 1, // 項目選擇在超過一頁時、目前所在頁數
      showMainItemNotice: false, // 是否顯示備註(配料)畫面
      noticeMainItem: {}, // 要顯示備註的項目
      additionalTypeTab: 0,
      additionalSelected: [], // 選擇的備註
      currentStepIndex: 0,
      keyboard: [
        ['1', '2', '3'],
        ['4', '5', '6'],
        ['7', '8', '9'],
      ],
      productTypeInfoById: this.$store.getters.productTypeInfoById,
      errorMessage: '',
    };
  },
  methods: {
    limitText(id) {
      const item = this.productTypeInfoById[id];
      const min = item.ueMinAdditionalItem || '';
      const max = item.ueMaxAdditionalItem || '';
      let result = '';
      if (min !== '' && max !== '') {
        result = `最少 ${min} 項 、 最多 ${max} 項`;
      }
      return result;
    },
    handleLimit(item) {
      const { productTypeId } = item;
      const max = Number(this.productTypeInfoById[productTypeId].ueMaxAdditionalItem) || '';
      const selectedArr = this.additionalSelected.filter((item) => item.productTypeId === productTypeId);
      if (max.length === 0) return false;
      if (selectedArr.length >= max && !selectedArr.includes(item)) return true;
      return false;
    },
    close() {
      this.isVisible = false;
      this.$emit('onDialogClose', this.itemSelected);
      this.orderStep = 0;
      this.tab = { ...defaultTabValue };
      this.orderDone = false;
      this.amountSelected = [];
      this.groupSelected = [];
      this.itemSelected = [];
      this.showMainItemNotice = false;
    },
    closeNotice() {
      this.showMainItemNotice = false;
      this.noticeMainItem = {};
    },
    getMenuImgSrc(productId) {
      try {
        const mainItem = this.$store.getters.mainProductsById[productId];
        if (mainItem) {
          const media = mainItem.productMedia;
          return (media && media.url) ? `${media.url}/${media.file_name}` : '';
        }
        return '';
      } catch {
        return '';
      }
    },
    getMenuItemName(productId) {
      const mainItem = this.$store.getters.mainProductsById[productId];
      if (mainItem && mainItem.productName) {
        return (this.language === 'en_US') ? mainItem.productEnglishName : mainItem.productName;
      }
      return '';
    },
    getMenuItemDescription(productId) {
      const mainItem = this.$store.getters.mainProductsById[productId];
      if (mainItem && mainItem.productIntroducing) {
        return mainItem.productIntroducing;
      }
      return '';
    },
    getProductTypeName(productTypeId) {
      const typeInfo = this.$store.getters.productTypeInfoById[productTypeId];
      if (typeInfo && typeInfo.productTypeName) {
        return (this.language === 'en_US') ? typeInfo.productTypeEnglishName : typeInfo.productTypeName;
      }
      return '';
    },

    getUnitedName(unitedName) {
      const names = unitedName.split('#');
      if (names.length === 1) {
        return names[0];
      }
      if (names.length === 2) {
        return (this.language === 'en_US') ? names[1] : names[0];
      }
      return '';
    },
    // 選擇完成，組成資料後回主畫面
    selectItem() {
      for (let i = 0; i < this.orderCount; i += 1) {
        this.itemSelected.push({
          isGroup: true,
          groupMainItem: { ...this.menuItem },
          groupSelectedItem: this.groupSelected,
          groupAmounts: this.amountSelected,
        });
      }
      this.close();
    },
    onItemSelecting(idx, gSelected) {
      const additional = this.getAdditional(gSelected.productId);
      if (additional.length) {
        this.currentStepIndex = idx;
        this.selectNotice(gSelected, additional);
      } else {
        this.nextStep(idx, gSelected, {});
      }
    },
    nextStep(idx, gSelected, items) {
      const additional = {};
      Object.values(items).forEach((item) => {
        const id = item[0].productTypeId;
        if (!additional[id]) {
          additional[id] = {
            productTypeName: this.productTypeInfoById[id].productTypeName,
            max: Number(this.productTypeInfoById[id].ueMaxAdditionalItem) || '',
            min: Number(this.productTypeInfoById[id].ueMinAdditionalItem) || '',
            count: 0,
          };
        }
      });
      this.additionalSelected.forEach((item) => {
        const id = item.productTypeId;
        if (additional[id]) additional[id].count += 1;
      });
      const errArr = [];
      Object.keys(additional).forEach((key) => {
        const item = additional[key];
        if (item.max !== '' && item.min !== '') {
          if (item.count < item.min) errArr.push(`${item.productTypeName} 最少 ${item.min} 項`);
          if (item.count > item.max) errArr.push(`${item.productTypeName} 最多 ${item.max} 項`);
        }
      });
      if (errArr.length > 0) {
        this.errorMessage = errArr.join(' 、 ');
        return;
      }
      // add selected into list
      let _amount = (gSelected.discountAmount) ? parseInt(gSelected.discountAmount, 10) : 0;
      let _selectedMainItem = this.$store.getters.mainProductsById[gSelected.productId];
      // 整理註記項目
      const _additional = Object.keys(this.selectedAdditionalByType);
      if (_additional.length) {
        const transformObj = { ...defaultAdditionalObj };
        _additional.forEach((type, index) => {
          if (index < 5) {
            const _selectedAdditional = this.selectedAdditionalByType[type];
            if (_selectedAdditional && _selectedAdditional.products) {
              const _additionalPrice = _selectedAdditional.products.reduce((_accu, _curr) => {
                let _price = 0;
                if (_curr.productPrice) _price = parseInt(_curr.productPrice, 10);
                return _accu + _price;
              }, 0);
              _amount += _additionalPrice;
            }
            transformObj[`additionalOfProduct${index + 1}`] = _selectedAdditional;
          }
        });
        _selectedMainItem = { ..._selectedMainItem, ...transformObj };
      }
      this.groupSelected.splice(idx, 1, _selectedMainItem);
      this.amountSelected.splice(idx + 1, 1, _amount);

      // move to next step
      if (this.orderStep >= this.stepMenu.length) {
        this.orderDone = true;
      }
      this.orderStep = Math.min(this.stepMenu.length + 1, idx + 2);

      // reset notice (additional) status
      this.noticeMainItem = {};
      this.additionalTypeTab = 0;
      this.additionalSelected = [];
      this.showMainItemNotice = false;
    },
    selectNotice(gSelected, additional) {
      const _selectedMainItem = this.$store.getters.mainProductsById[gSelected.productId];
      this.noticeMainItem = {
        ..._selectedMainItem,
        additional,
        discountAmount: gSelected.discountAmount,
      };
      this.showMainItemNotice = true;
    },
    keyIn(char) {
      this.orderCount = parseInt(char, 10);
    },
    handleDialogClose() {
    },
    getAdditional(productId) {
      // find additional products
      return this.$store.getters.additionalProductInfo.filter((p) => {
        const _parentIds = p.parentProductId.split(',');
        return _parentIds.indexOf(productId) > -1;
      });
    },
    getAdditionalName(item) {
      let result = '';
      if (item.productName) {
        result = (this.language === 'en_US') ? item.productEnglishName : item.productName;
        if (item.productPrice) {
          result += `: +$${item.productPrice}`;
        }
      }
      return result;
    },
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    stepMenu: {
      get() {
        // console.log('menuItem', this.menuItem);
        return this.menuItem.productExtraInfo ?? [];
      },
    },
    subTotal: {
      get() {
        return this.amountSelected.reduce((prev, curr) => prev + curr, 0) * this.orderCount;
      },
    },
    selectedIds: {
      get() {
        return this.groupSelected.map((selected) => selected.productId);
      },
    },
    noticeMainItemInfo() {
      const info = {
        imgSrc: '',
        additionTypes: [],
        productName: '',
      };
      const type = {};
      const media = this.noticeMainItem.productMedia;
      info.imgSrc = (media && media.url) ? `${media.url}/${media.file_name}` : '';
      if (this.noticeMainItem.additional) {
        this.noticeMainItem.additional.forEach((item) => {
          const _name = item.productTypeName;
          if (!type[_name]) type[_name] = [];
          type[_name].push(item);
        });
      }
      info.additionTypes = type;
      info.productName = (this.language === 'en_US') ? this.noticeMainItem.productEnglishName : this.noticeMainItem.productName;
      return info;
    },
    selectedAdditionalByType() {
      const selectedObj = {};
      this.additionalSelected.forEach((selected) => {
        if (!selectedObj[selected.productTypeId]) {
          selectedObj[selected.productTypeId] = {
            productTypeId: selected.productTypeId,
            productTypeName: selected.productTypeName,
            productTypeEnglishName: selected.productTypeEnglishName,
            products: [],
          };
        }
        selectedObj[selected.productTypeId].products.push(selected);
      });
      return selectedObj;
    },
  },
  watch: {
    dialog(val) {
      this.isVisible = val;
      if (val) {
        this.itemSelected = []; // reset
        // initial setting
        this.groupSelected = new Array(this.stepMenu.length);
        this.amountSelected = new Array(this.stepMenu.length + 1); // with initial price
        this.groupSelected.fill('');
        this.amountSelected.fill(0);

        // initial price
        this.amountSelected[0] = parseInt(this.menuItem.productGroupPrice, 10);
        // show items (have to defer because of Vuetify's bug)
        setTimeout(() => {
          this.orderStep = 1;
          this.orderCount = 1;
        }, 100);
      }
    },
  },
};
</script>
<style>
.v-stepper__label {
  display: block !important;
  font-weight: bold;
  font-size: 0.8em;
}

.checkbox-large .v-icon.v-icon {
  font-size: 1.5em;
}

.checkbox-large .v-label {
  font-size: 1.6em;
  font-weight: bold;
}
</style>
